import React, { useState } from 'react';

const betriebsstellen = [
  { name: 'Sägewerk', gueterarten: ['Holzbretter', 'Langholz Baumstämme', 'Schüttgut Späne', 'Schwergut Maschinen'] },
  { name: 'Ladegleis', gueterarten: ['Stückgut Paletten', 'Stückgut Kisten', 'Schwergut Maschinen'] },
  { name: 'Güterschuppen', gueterarten: ['Stückgut Paletten', 'Stückgut Kisten', 'Kühlgut Lebensmittel', 'Kühlgut Pharma', 'Schwergut Maschinen', 'Holzbretter',] },
  { name: 'Ladekran', gueterarten: ['Schwergut Maschinen', 'Schwergut Transformatoren'] },
  { name: 'Ortsgüteranlage', gueterarten: ['Stückgut Paletten', 'Flüssiggut Lebensmittel', 'Schüttgut', 'Bauzug'] },
  { name: 'Brauerei', gueterarten: ['Flüssiggut Lebensmittel', 'Schüttgut Getreide'] },
  { name: 'Chemiebetrieb', gueterarten: ['Gefahrgut Chemikalien'] },
  { name: 'Loktankstelle', gueterarten: ['Flüssiggut Diesel', 'Flüssiggut Öl'] },
  { name: 'Kohlebansen', gueterarten: ['Schüttgut Kohle'] },
  { name: 'Betriebswerk', gueterarten: ['Schüttgut Kohle', 'Flüssiggut Öl', 'Bauzug'] },
  { name: 'Lokschuppen', gueterarten: ['Schwergut Maschinen', 'Bauzug'] },
  { name: 'Gleisbaustelle', gueterarten: ['Bauzug', 'Schüttgut Schotter'] },
  { name: 'Schotterwerk', gueterarten: ['Schüttgut Schotter'] },
  { name: 'Kieswerk', gueterarten: ['Schüttgut Kies'] },
  { name: 'Möbelwerk', gueterarten: ['Holzbretter', 'Schwergut Maschinen', 'Stückgut Kisten', 'Schüttgut Späne'] },
  { name: 'Verladerampe', gueterarten: ['Fahrzeuge PKW', 'Fahrzeuge LKW', 'Bauzug'] },
  { name: 'Containerterminal', gueterarten: ['Container 20ft', 'Container 40ft'] },
  { name: 'Rangierbahnhof', gueterarten: ['Stückgut Paletten',
                     'Stückgut Kisten',
                     'Schüttgut Kohle',
                     'Schüttgut Kies',
                     'Schüttgut Schotter',
                     'Schüttgut Getreide',
                     'Schüttgut Späne',
                     'Flüssiggut Öl',
                     'Flüssiggut Diesel',
                     'Flüssiggut Lebensmittel',
                     'Flüssiggut Chemikalien',
                     'Kühlgut Lebensmittel',
                     'Kühlgut Pharma',
                     'Container 20ft',
                     'Container 40ft',
                     'Holzbretter',
                     'Langholz Baumstämme',
                     'Schwergut Maschinen',
                     'Schwergut Transformatoren',
                     'Fahrzeuge PKW',
                     'Fahrzeuge LKW',
                     'Bauzug'] },
  { name: 'Abstellung', gueterarten: ['Stückgut Paletten',
                     'Stückgut Kisten',
                     'Schüttgut Kohle',
                     'Schüttgut Kies',
                     'Schüttgut Schotter',
                     'Schüttgut Getreide',
                     'Schüttgut Späne',
                     'Flüssiggut Öl',
                     'Flüssiggut Diesel',
                     'Flüssiggut Lebensmittel',
                     'Flüssiggut Chemikalien',
                     'Kühlgut Lebensmittel',
                     'Kühlgut Pharma',
                     'Container 20ft',
                     'Container 40ft',
                     'Holzbretter',
                     'Langholz Baumstämme',
                     'Schwergut Maschinen',
                     'Schwergut Transformatoren',
                     'Fahrzeuge PKW',
                     'Fahrzeuge LKW',
                     'Bauzug'] },


];

const gueterarten = ['Stückgut Paletten',
                     'Stückgut Kisten',
                     'Schüttgut Kohle',
                     'Schüttgut Kies',
                     'Schüttgut Schotter',
                     'Schüttgut Getreide',
                     'Schüttgut Späne',
                     'Flüssiggut Öl',
                     'Flüssiggut Diesel',
                     'Flüssiggut Lebensmittel',
                     'Flüssiggut Chemikalien',
                     'Kühlgut Lebensmittel',
                     'Kühlgut Pharma',
                     'Container 20ft',
                     'Container 40ft',
                     'Holzbretter',
                     'Langholz Baumstämme',
                     'Schwergut Maschinen',
                     'Schwergut Transformatoren',
                     'Fahrzeuge PKW',
                     'Fahrzeuge LKW',
                     'Bauzug'];

function App() {
  const [auftrag, setAuftrag] = useState(null);

  const generiereAuftrag = () => {
    const gueterart = gueterarten[Math.floor(Math.random() * gueterarten.length)];
    const passendeBetriebsstellen = betriebsstellen.filter(b =>
      b.gueterarten.includes(gueterart)
    );

    if (passendeBetriebsstellen.length < 2) {
      alert('Nicht genug Betriebsstellen für diese Güterart!');
      return;
    }

    let start, ziel;
    do {
      start = passendeBetriebsstellen[Math.floor(Math.random() * passendeBetriebsstellen.length)];
      ziel = passendeBetriebsstellen[Math.floor(Math.random() * passendeBetriebsstellen.length)];
    } while (start.name === ziel.name);

    const menge = Math.floor(Math.random() * 3) + 1;

    setAuftrag({
      start: start.name,
      ziel: ziel.name,
      gueterart,
      menge,
    });
  };

  return (
    <div style={{ padding: 20, fontFamily: 'Arial' }}>
      <h1>Modellbahn Frachtauftrag</h1>
      <p><button className="mybutton" onClick={generiereAuftrag}>Neuen Auftrag generieren</button></p>
      {auftrag && (
        <div style={{ marginTop: 20, border: '1px solid gray', padding: 10 }}>
          <h2>Dein Auftrag:</h2>
          <p><strong>Start:</strong> {auftrag.start}</p>
          <p><strong>Ziel:</strong> {auftrag.ziel}</p>
          <p><strong>Güterart:</strong> {auftrag.gueterart}</p>
          <p><strong>Menge:</strong> {auftrag.menge} Wagen</p><p><strong>Auftragsdetails:</strong></p>
      
      <p>1. Stelle einen für die Strecke geeigneten Zug mit {auftrag.menge} Wagen für {auftrag.gueterart} zusammen.</p><p>2. Bringe {auftrag.menge} Wagen für {auftrag.gueterart} zur Betriebsstelle {auftrag.start}.</p><p>3. Bringe die Wagen anschließend zur Betriebsstelle {auftrag.ziel}. </p>
        </div>
      )}
    </div>
  );
}

export default App;
